import VSnackbar from './VSnackbar'

/* istanbul ignore next */
VSnackbar.install = function install (Vue) {
  Vue.component(VSnackbar.name, VSnackbar)
}

export { VSnackbar }
export default VSnackbar
